import { styled } from "@mui/material";
import Typography from "../../ontego-ui/components/Typography";

export const RegisterContainer = styled("div")(({ theme }) => ({
  flexGrow: 1,
  boxSizing: "border-box",
  maxHeight: "100%",
  margin: "0px 24px 24px 24px",
  [theme.breakpoints.up("sm")]: {
    margin: "48px 48px 0px 48px",
  },
  [theme.breakpoints.up("md")]: {
    margin: "64px 90px 64px 120px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  letterSpacing: "unset",
  lineHeight: "28px",
  marginBottom: 16,
  [theme.breakpoints.up("sm")]: {
    lineHeight: "32px",
    marginBottom: 24,
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  letterSpacing: "unset",
  lineHeight: "20px",
  marginBottom: 20,
  [theme.breakpoints.up("sm")]: {
    lineHeight: "22px",
    marginBottom: 23,
  },
}));
